// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"c83e5f96","359":"c83e5f96","361":"a38b4817","415":"c83e5f96","604":"94787688","742":"a38b4817","828":"4570a679"}[chunkId] + ".chunk.css";
};